/*
 * COMING SOON
 * 発売日時（商品メタフィールド custom.release_date）になったら、ページを再読み込みしなくても
 * グレーアウトしたボタンを「カートに追加」に戻し、「発売予定」の表示とバッジを外します。
 * ページのキャッシュで Liquid の判定が少し遅れる場合も、ここで発売時刻ちょうどに切り替わります。
 */
(() => {
  const MAX_TIMEOUT = 2147483647; // setTimeout の上限（約24.8日）

  const isReleased = (releaseSeconds) => Date.now() >= parseInt(releaseSeconds, 10) * 1000;

  class ComingSoonTimer extends HTMLElement {
    connectedCallback() {
      const remaining = parseInt(this.getAttribute('release'), 10) * 1000 - Date.now();

      if (Number.isNaN(remaining)) return;

      if (remaining <= 0) {
        this.unlock();
      } else if (remaining < MAX_TIMEOUT) {
        this.timeout = setTimeout(() => this.unlock(), remaining);
      }
    }

    disconnectedCallback() {
      clearTimeout(this.timeout);
    }

    unlock() {
      const buyButtons = this.closest('buy-buttons') || this.parentElement?.querySelector('buy-buttons');

      if (buyButtons) {
        buyButtons.classList.remove('buy-buttons--coming-soon');

        const button = buyButtons.querySelector('button[type="submit"]');

        if (button) {
          button.textContent = this.getAttribute('label');

          if (this.hasAttribute('sold-out')) {
            button.classList.add('button--outline');
          } else {
            button.disabled = false;
          }
        }
      }

      removeExpiredLabels();
      this.remove();
    }
  }

  // 「発売予定」の表示と Coming Soon バッジ（商品カードを含む）を、発売時刻を過ぎたものから外す
  const removeExpiredLabels = () => {
    document.querySelectorAll('[data-coming-soon-release]').forEach((element) => {
      if (isReleased(element.getAttribute('data-coming-soon-release'))) {
        element.remove();
      }
    });
  };

  if (!window.customElements.get('coming-soon-timer')) {
    window.customElements.define('coming-soon-timer', ComingSoonTimer);
  }

  removeExpiredLabels();
  setInterval(removeExpiredLabels, 30000);
})();
